import { ButtonLoader } from '@wellesley/ui'
import { FC, PropsWithChildren } from 'react'

type TReportLayout = PropsWithChildren<{
  isLoading?: boolean
  rightButtonTitle?: string
  isDisabledSubmit?: boolean
  onRightButtonClick?(): void
}>

const ReportLayout: FC<TReportLayout> = ({
  children,
  isLoading,
  rightButtonTitle,
  isDisabledSubmit,
  onRightButtonClick,
}) => (
  <div className="w-full">
    <div className="p-m w-full">{children}</div>

    {onRightButtonClick && (
      <div className="p-m flex justify-end border-t border-gray-200">
        <ButtonLoader
          size="m"
          variant="primary"
          data-testid="submit-btn"
          className="mt-xxxs ml-auto block capitalize"
          isLoading={!!isLoading}
          onClick={onRightButtonClick}
          disabled={isDisabledSubmit}
        >
          {rightButtonTitle}
        </ButtonLoader>
      </div>
    )}
  </div>
)

export default ReportLayout
